// Keep cart updates working when Shopify replaces a section.
let cartUpdateTimer;
function scheduleCartUpdate(event) {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || input.name !== 'updates[]') return;
  const cartForm = input.closest('[data-cart-form]');
  if (!cartForm) return;
  window.clearTimeout(cartUpdateTimer);
  cartUpdateTimer = window.setTimeout(() => {
    if (!cartForm.isConnected) return;
    const fields = [...cartForm.querySelectorAll('input[name="updates[]"]')];
    const valid = fields.every(field => field.value.trim() !== '' &&
      Number.isInteger(Number(field.value)) && Number(field.value) >= 0 && field.validity.valid);
    const updateButton = cartForm.querySelector('[data-cart-update]');
    if (valid && updateButton) cartForm.requestSubmit(updateButton);
  }, 600);
}
document.addEventListener('input', scheduleCartUpdate);
document.addEventListener('change', scheduleCartUpdate);

// On mobile, take package buttons straight to the choices.
document.addEventListener('click', event => {
  const link = event.target instanceof Element ? event.target.closest('a[href="#bestall"]') : null;
  if (!link || !window.matchMedia('(max-width: 760px)').matches) return;
  const choices = document.querySelector('#PalsvantenForm');
  if (!choices) return;
  event.preventDefault();
  choices.scrollIntoView({block: 'start', behavior:
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
});

document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('#PalsvantenForm');
  if (!form) return;
  // Use Shopify's Ajax response so analytics receives the selected variant and price.
  let addingPackage = false;
  const packageSubmitButton = form.querySelector('button[type="submit"]');
  const packageSubmitText = packageSubmitButton?.textContent;
  // Re-enable the button when Back restores this page from the browser cache.
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted || !addingPackage) return;
    addingPackage = false;
    form.removeAttribute('aria-busy');
    if (packageSubmitButton) {
      packageSubmitButton.disabled = false;
      packageSubmitButton.textContent = packageSubmitText;
    }
  });
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (addingPackage) return;
    const selectedPackage = form.querySelector('input[name="id"]:checked');
    if (!selectedPackage) return;
    const giftItems = selectedPackage.dataset.package === 'triple'
      ? [
          {
            id: Number(selectedPackage.value),
            quantity: 1,
            properties: { _pf_package: 'triple', _pf_role: 'paid' }
          },
          {
            id: 55201993720135,
            quantity: 2,
            properties: { _pf_package: 'triple', _pf_role: 'gift' }
          }
        ]
      : [
          {
            id: 54839058760007,
            quantity: 1,
            properties: { _pf_package: 'single', _pf_role: 'paid' }
          },
          {
            id: 55201264828743,
            quantity: 1,
            properties: { _pf_package: 'single', _pf_role: 'gift' }
          }
        ];
    const button = form.querySelector('button[type="submit"]');
    const message = form.querySelector('[data-form-message]');
    const buttonText = button?.textContent;
    const root = window.Shopify?.routes?.root || '/';
    addingPackage = true;
    form.setAttribute('aria-busy', 'true');
    if (message) message.textContent = '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Lägger till…';
    }
    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: giftItems })
      });
      if (!response.ok) {
        if (message) message.textContent = 'Produkten kunde inte läggas till. Försök igen.';
      } else {
        await response.json();
        if (typeof window.pfCartOpen === 'function') await window.pfCartOpen();
        else window.location.assign(root + 'cart');
      }
    } catch (error) {
      if (message) message.textContent = 'Vi kunde inte bekräfta tillägget. Kontrollera varukorgen innan du försöker igen.';
    }
    addingPackage = false;
    form.removeAttribute('aria-busy');
    if (button) {
      button.disabled = false;
      button.textContent = buttonText;
    }
  });

  const options = [...form.querySelectorAll('.variant-option')];
  const price = form.querySelector('[data-selected-price]');
  const packageImage = document.querySelector('[data-package-image]');
  const packageBadge = document.querySelector('[data-package-badge]');
  const packageRating = document.querySelector('[data-package-rating]');
  const heroPrice = document.querySelector('[data-hero-price]');
  const heroPill = document.querySelector('[data-hero-pill]');
  const mobilePackage = document.querySelector('[data-mobile-package]');
  const mobilePrice = document.querySelector('[data-mobile-price]');
  options.forEach((option) => {
    const input = option.querySelector('input');
    input?.addEventListener('change', () => {
      options.forEach((item) => item.classList.remove('selected'));
      option.classList.add('selected');
      if (price) price.textContent = input.dataset.price || '';
      if (packageImage) {
        const isTriple = input.dataset.package === 'triple';
        packageImage.src = input.dataset.image || packageImage.src;
        packageImage.alt = isTriple
          ? 'Tre Pälsvantar i Baby Pink, blått och svart med gula detaljer'
          : 'Svart Pälsvante med gul detalj';
        if (packageBadge) packageBadge.textContent = isTriple ? '3-PACK · BÄST VÄRDE' : '1-PACK · SVART';
        if (packageRating) {
          const label = packageRating.querySelector('span');
          const detail = packageRating.querySelector('small');
          if (label) label.textContent = isTriple ? 'BABY PINK · BABY BLUE · SVART' : 'SVART';
          if (detail) detail.textContent = isTriple ? 'En färg för varje område' : 'En vante för ett område';
        }
        if (heroPrice) heroPrice.textContent = `${isTriple ? '3-pack' : '1-pack'} ${input.dataset.price || ''}`;
        if (heroPill) heroPill.textContent = isTriple ? '3-PACK · SPARA 98 KR' : '199 KR + 69 KR FRAKT';
        if (mobilePackage) mobilePackage.textContent = isTriple ? '3-pack' : '1-pack';
        if (mobilePrice) mobilePrice.textContent = input.dataset.price || '';
      }
    });
  });

});
